import { render, staticRenderFns } from "./CancelledEntitlement.vue?vue&type=template&id=65b7f54a&scoped=true&"
import script from "./CancelledEntitlement.vue?vue&type=script&lang=js&"
export * from "./CancelledEntitlement.vue?vue&type=script&lang=js&"
import style0 from "./CancelledEntitlement.vue?vue&type=style&index=0&id=65b7f54a&prod&lang=scss&scoped=true&"
import style1 from "./CancelledEntitlement.vue?vue&type=style&index=1&id=65b7f54a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b7f54a",
  null
  
)

export default component.exports